import { Link } from 'react-router-dom';
import { strategies } from '../data/strategiesData';
import { formatILS, formatPercent } from '../utils/format';
import RiskBadge from '../components/ui/RiskBadge';
import imgHighrise from '../assets/images/highrise-sea.jpg';
import imgInterior from '../assets/images/interior-living.jpg';
import imgFacade from '../assets/images/building-facade.jpg';

const CARD_HEADERS = [
  `linear-gradient(135deg, rgba(13,31,60,0.82) 0%, rgba(26,58,108,0.82) 100%), url(${imgHighrise}) center/cover`,
  `linear-gradient(135deg, rgba(15,51,32,0.82) 0%, rgba(26,92,58,0.82) 100%), url(${imgInterior}) center/cover`,
  `linear-gradient(135deg, rgba(61,26,0,0.82) 0%, rgba(122,58,0,0.82) 100%), url(${imgFacade}) center/cover`,
];

export default function Strategies() {
  return (
    <div className="page-content">
      <div className="container">
        <div className="section-header" style={{ textAlign: 'left' }}>
          <span className="gold-tag">Idées d'investissement</span>
          <h1 style={{ marginTop: '0.5rem' }}>Nos 3 idées d'investissement</h1>
          <p>Trois profils types pour investir en Israël en 2024–2025, avec chiffres indicatifs et analyse des risques.</p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          {strategies.map((s, idx) => (
            <div key={s.id} style={{ background: 'var(--color-bg-white)', borderRadius: 'var(--radius-xl)', border: '1px solid var(--color-border)', overflow: 'hidden', boxShadow: 'var(--shadow-sm)' }}>
              {/* Header */}
              <div style={{ background: CARD_HEADERS[idx], padding: '2rem 2.25rem', color: '#fafaf8', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                <div>
                  <span style={{ display: 'inline-block', fontFamily: 'var(--font-body)', fontSize: '0.68rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(196,163,90,0.85)', marginBottom: '0.5rem' }}>
                    Stratégie {String(idx + 1).padStart(2, '0')}
                  </span>
                  <h2 style={{ color: '#fafaf8', margin: 0, fontSize: '1.6rem' }}>{s.title}</h2>
                  <p style={{ color: 'rgba(250,250,248,0.72)', margin: '0.3rem 0 0', fontSize: '0.95rem' }}>{s.subtitle}</p>
                </div>
                <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                  <div style={{ background: 'rgba(255,255,255,0.10)', borderRadius: 'var(--radius-md)', padding: '0.75rem 1.25rem', textAlign: 'center', border: '1px solid rgba(255,255,255,0.12)' }}>
                    <div style={{ fontSize: '1.15rem', fontWeight: 700, fontFamily: 'var(--font-display)' }}>
                      {formatILS(s.priceRange.min, true)} – {formatILS(s.priceRange.max, true)}
                    </div>
                    <div style={{ fontSize: '0.68rem', opacity: 0.72, textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 2 }}>Budget indicatif</div>
                  </div>
                  <div style={{ background: 'rgba(255,255,255,0.10)', borderRadius: 'var(--radius-md)', padding: '0.75rem 1.25rem', textAlign: 'center', border: '1px solid rgba(255,255,255,0.12)' }}>
                    <div style={{ fontSize: '1.15rem', fontWeight: 700, fontFamily: 'var(--font-display)' }}>
                      {s.grossYieldRange.min}–{s.grossYieldRange.max} %
                    </div>
                    <div style={{ fontSize: '0.68rem', opacity: 0.72, textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 2 }}>Rendement brut</div>
                  </div>
                </div>
              </div>

              {/* Body */}
              <div style={{ padding: '2rem 2.25rem' }}>
                <div className="grid-2" style={{ marginBottom: '1.5rem' }}>
                  <div>
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
                      <RiskBadge level={s.riskLevel} />
                      <span className="badge badge-blue">Horizon : {s.horizon}</span>
                      <span className="badge badge-neutral">{s.profile}</span>
                    </div>
                    <p style={{ color: 'var(--color-text)', lineHeight: 1.8, margin: 0, fontSize: '0.95rem' }}>{s.description}</p>
                    <div style={{ marginTop: '1rem', padding: '0.875rem 1rem', background: 'var(--color-surface)', borderRadius: 'var(--radius-md)', fontSize: '0.875rem', borderLeft: '2px solid var(--color-border)' }}>
                      <strong style={{ fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--color-text-muted)' }}>Bien type</strong>
                      <div style={{ marginTop: 4, color: 'var(--color-text)' }}>{s.typicalAsset}</div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1.25rem' }}>
                      <div style={{ fontWeight: 700, fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--color-success)', marginBottom: '0.625rem' }}>Points forts</div>
                      <ul style={{ margin: 0, paddingLeft: '1.1rem' }}>
                        {s.pros.map((p, i) => <li key={i} style={{ fontSize: '0.875rem', marginBottom: '0.3rem', lineHeight: 1.6 }}>{p}</li>)}
                      </ul>
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--color-warning)', marginBottom: '0.625rem' }}>Points de vigilance</div>
                      <ul style={{ margin: 0, paddingLeft: '1.1rem' }}>
                        {s.cons.map((c, i) => <li key={i} style={{ fontSize: '0.875rem', marginBottom: '0.3rem', lineHeight: 1.6 }}>{c}</li>)}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Conseil box */}
                <div style={{ borderLeft: '3px solid var(--color-accent)', background: 'rgba(196,163,90,0.06)', padding: '1rem 1.25rem', borderRadius: '0 var(--radius-md) var(--radius-md) 0', marginBottom: '1.5rem' }}>
                  <div style={{ fontSize: '0.68rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--color-accent)', marginBottom: '0.4rem' }}>Conseil</div>
                  <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--color-text)', lineHeight: 1.7 }}>{s.tip}</p>
                </div>

                <Link to="/accompagnement" className="btn btn-primary">Discuter de ce profil avec nous</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
